import React, { Component } from 'react';


class Multi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:[],
      ck_list:[[],[],[],[],[],[],[],[],[],[]]
    };
  }
 
  subCard=(questionId,opt,grade,index,questionType,e)=>{
   let ck_list=this.state.ck_list;
   let optList=opt.split(",");
   Array.prototype.equals = function(arr)
{
    return this.sort().join() === arr.sort().join()
}
   if(ck_list[index].includes(e.target.value)){
    ck_list[index].splice(ck_list[index].findIndex(item => item === e.target.value), 1);
  }else{
    ck_list[index].push(e.target.value);
  }
  //console.log(ck_list);
    this.setState({
      ck_list:ck_list
    })


  if(optList.equals(ck_list[index])&&ck_list[index].length>0){
    this.props.subCard(questionId,this.state.ck_list[index].join(","),1,grade,questionType);
  }else{
    this.props.subCard(questionId,this.state.ck_list[index].join(","),0,0,questionType);
  }
     
   
  }
  imgShow=(e)=>{

    this.props.imgShow(e);
  }
  componentDidMount(){
    this.setState({
      data: this.props.data,
      
    })  
  }
  // componentWillReceiveProps = (nextProps) => {
  //   this.setState({
  //     data: nextProps.data
  //   })    
    
  // }
  render() {
    if(this.state.data&&this.state.data.length>0){
      return (
        <div>
          <div className="qus_title">
           {/* {this.props.listXX}:多项选择题（本大题共 {this.props.data.length} 小题） */}
            </div>
            {
              this.state.data.map((val,index)=>{
                return( 
                  <div key={index}>
                <div className="single_title" onClick={this.imgShow} >
                {this.props.Skey}.({this.props.listXX}题)<span dangerouslySetInnerHTML = {{ __html:val.question }}></span>({val.questionGrade}分)
                </div>
                {
                val.answerList.map((value,key)=>{
                  if(val.cardList&&val.cardList.length>0){
                    return(
                      <label className="Multi_sel" key={key}>
                      <input type="checkbox" name="muti" disabled  value={value.answerNum} checked={val.cardList[0].optChoose!==null&&val.cardList[0].status=='1'?val.cardList[0].optChoose.split(",").includes(value.answerNum):""} onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>{value.answerNum}. {value.answerName}</span>
                      </label>
                
                     )
                  }
                  else{
                    return(
                      <label className="Multi_sel" key={key}>
                      <input type="checkbox" name="muti" value={value.answerNum} onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,index,val.questionType)} /><i></i><span>{value.answerNum}. {value.answerName}</span>
                      </label>
                
                     )
                  }
             
                })
              }
               {
                  this.props.ansShow===true&&this.props.isDid===true?
                  <div className="ans_con">
                  <div className="ans_title">正确答案是 <span className="ans_right">{val.optionTrue}</span></div>
                  <div className='ans_tip'>解析</div>
                  <div className="ans_jx" onClick={this.imgShow}><span dangerouslySetInnerHTML = {{ __html:val.analysis}}></span></div>
                  </div>
                 :
                 <div className="ans_cli"></div>
              }
               
                 </div>
                )
              })
            }
        
        </div>
      );
    }else{
      return(<div></div>)
    }
    
  }
}

export default Multi;
